import React, { useEffect, useState } from "react"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';
import CustomTextField from "../../../components/Form/CustomTextField";

const CancelOrder = (props) => {
    const [reason, setReason] = useState();

    const handleSubmit = () => {
        props.submit(reason);
    }

    return (
        <AppDialog
            open={props.open}
            close={() => {props.close(); setReason('')}}
            title={'Cancel order'}
            titleIcon={'error'}
            positiveTitle={'Cancel order'}
            positivePress={() => handleSubmit()}
            positiveButtonStyle={{backgroundColor: '#ED1A3D', color: 'white', border: '1px solid #ED1A3D'}}
            negativePress={() => {props.close(); setReason('')}}
            negativeTitle={'Cancel'}
            width={'30%'}
        >
            <div className="">
                <CustomTextField
                    title={'Reason:'}
                    values={reason}
                    onChange={setReason}
                    multiline={true}
                    rows={4}
                />
            </div>
        </AppDialog>
    )
}

export default CancelOrder;